<template>
    <ai-grid-edit ref="gridRef" :meta="meta" @editGridMounted="onEditGridMounted" />
</template>
<script>
export default {
    name: 'spr-smet-zatr-calc',
};
</script>

<script setup>
import { onMounted, ref } from 'vue';
import aiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';
import { meta } from './meta';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import { setTabReadyToSaveValue } from '@/layouts/main-layout/components/navigation-bars-data';

const gridRef = ref();
const gridInstance = ref();
const updateInProgress = ref(false);
const lastMonthOfYear = '12';

onMounted(() => {});

const onEditGridMounted = async () => {
    gridInstance.value = gridRef.value.gridInstance;
    gridInstance.value.on('focusedCellChanged', onFocusedCellChanged);
    gridInstance.value.on('optionChanged', onOptionChanged);

    setActiveViewInfo({ refresh: gridRef.value.setDataSource, userData: () => {}, userSettings: () => {} });

    await setViewData();
    setTabReadyToSaveValue(true);
};

const onFocusedCellChanged = event => {
    if (event.column && event.column.dataField === 'storn') {
        const month = String(event.row.data.period_po).split('.')[1];
        if (!event.row.data.period_po || month === lastMonthOfYear) {
            gridInstance.value.columnOption('storn', 'allowEditing', false);
        } else {
            gridInstance.value.columnOption('storn', 'allowEditing', true);
        }
    }
};

const onOptionChanged = async event => {
    if (event.fullName === 'editing.changes' && !updateInProgress.value) {
        for (let obj of event.value) {
            if (obj.type === 'update') {
                updateInProgress.value = true;
                try {
                    const keysToUpdate = [];
                    const data = obj.data;
                    const field = Object.hasOwn(data, 'period_po');
                    if (field) {
                        const month = data.period_po.split('.')[1];
                        if (month === lastMonthOfYear) {
                            keysToUpdate.push(obj.key);
                        }
                    }
                    if (keysToUpdate.length > 0) {
                        await updateStornCell(keysToUpdate);
                    }
                } finally {
                    updateInProgress.value = false;
                }
            }
        }
    }
};

const updateStornCell = async keysToUpdate => {
    const newChanges = gridInstance.value.option('editing.changes').map(change => {
        return keysToUpdate.includes(change.key)
            ? { ...change, data: { ...change.data, storn: change.data.storn === true ? false : change.data.storn } }
            : change;
    });

    gridInstance.value.option('editing.changes', newChanges);
    gridInstance.value.refresh();
};
</script>
